import { gql } from '@apollo/client';

export const GET_ESG_CATEGORIES = gql`
  query EsgCategories($categoryLevel: EsgCategoryLevel!) {
    esgCategories(categoryLevel: $categoryLevel) {
      area
      id
      title
      reportChapters {
        id
        label
      }
    }
  }
`;
